import * as React from "react";
import {CSSProperties} from "react";
import {HotKeys} from "react-hotkeys";

import "./checkbox.scss";
import classNames = require("classnames");

interface ComponentProps {
	/**
	 * Indicates if checkbox is checked.
	 */
	checked: boolean;
	/**
	 * On check action.
	 */
	onChange?: (value: boolean) => void;
	/**
	 * Text for label.
	 */
	label?: string;
	/**
	 * Required mark.
	 */
	requiredMark?: boolean;
	/**
	 * Disable flag.
	 */
	disabled?: boolean;
	/**
	 * Inline styles
	 */
	styles?: CSSProperties,
	/**
	 * Custom class
	 */
	customClass?: string
}

/**
 * Base checkbox component.
 */
export default class Checkbox extends React.PureComponent<ComponentProps, {}> {
	/**
	 * Hot keys map.
	 */
	hotKeysMap = {
		onEnter: 'enter'
	};

	/**
	 * Hot keys handlers
	 */
	hotKeysHandlers: any;

	constructor(props: ComponentProps) {
		super(props);
		this.hotKeysHandlers = {
			onEnter: () => this.props.onChange && this.props.onChange(!this.props.checked)
		}
	}

	render() {
		const classFromProps = classNames({
			"a-checkbox": true,
			[`${this.props.customClass}`]: !!this.props.customClass
		});
		const styleFromProps = {
			cursor: this.props.disabled ? "not-allowed" : "pointer",
			opacity: this.props.disabled ? 0.8 : 1,
			...this.props.styles
		};

		return (
			<HotKeys keyMap={this.hotKeysMap} handlers={this.hotKeysHandlers}>
				<div className={classFromProps} style={styleFromProps} onClick={(e) => e.stopPropagation()}>
					<label tabIndex={0} style={styleFromProps}>
						<input type="checkbox"
							   tabIndex={-1}
							   checked={this.props.checked}
							   disabled={this.props.disabled}
							   onChange={() => this.props.onChange && this.props.onChange(!this.props.checked)}/>
						{this.props.label}
						{this.props.requiredMark && <span style={{color: "red"}}> *</span>}
						<span/>
					</label>
				</div>
			</HotKeys>
		);
	}
}
